import ServerAddonsView from "@/systems/admin/ServerAddonsView.vue";
import CommunitiesView from "@/systems/admin/CommunitiesView.vue";
import {adminRoles} from "@/systems/main/adminRoles.js";
import EditGlobalAlertView from "@/systems/admin/EditGlobalAlertView.vue";
import AdminDashboardView from "@/systems/admin/AdminDashboardView.vue";
import {RouterView} from "vue-router";
import authorization from "@/authorization";

export default [
    {
        name: "admin",
        path: "/admin",
        props: true,
        component: RouterView,
        meta: {
            authorize: () => authorization.adminRole(adminRoles.superAdmin),
        },
        redirect: { name: "admin.dashboard" },
        children: [
            {
                name: "admin.dashboard",
                path: "dashboard",
                component: AdminDashboardView,
                meta: {
                    authorize: () => authorization.adminRole(adminRoles.superAdmin),
                },
            },
            {
                name: "admin.communities",
                path: "communities",
                component: CommunitiesView
            },
            {
                name: "admin.communities.serverAddons",
                path: "server-addons",
                component: ServerAddonsView,
                meta: {
                    authorize: () => authorization.adminRole(adminRoles.superAdmin),
                },
            },
            {
                name: "admin.globalAlert",
                path: "alert/global",
                component: EditGlobalAlertView,
                meta: {
                    authorize: () => authorization.adminRole(adminRoles.superAdmin),
                },
            },
        ]
    }
];